<template>
  <div id="top-up form" class="tw-px-8">
    <form class="tw-w-full tw-mt-10" @submit.prevent="topUp">
      <div class="tw-mb-8">
        <h3 class="tw-text-xl tw-font-semibold tw-mt-8">Top up shares</h3>
        <p class="tw-text-gray">How many shares would you like to add?</p>
      </div>
      <NumberInput
        placeHolder="Number of shares"
        label="Number of shares"
        :number="payload.amount"
        :maxNumber="String(maxAmount)"
        type="text"
        fieldType="amount"
        name="numberOfShares"
        id="numberOfShares"
        @set="setAmount"
        @valid="shareNumberValid"
        @validate="validate"
      />
      <p class="tw-text-sm tw-text-gray tw-mt-2">
        Shares left: {{ convertToLocale(maxAmount) }}
      </p>
      <Btn class="tw-mt-8" title="Top Up" />
    </form>
  </div>
</template>

<script>
import NumberInput from "@/components/general/NumberInput";
import Btn from "@/components/general/BtnComponent.vue";
import { convertToLocale } from "@/utils/helpers.js";

export default {
  name: "TopUpForm",

  components: {
    NumberInput,
    Btn,
  },

  props: {
    esopToken: { type: Object, default: () => {}, required: true },
  },

  data() {
    return {
      amountValid: false,
      validInput: {
        amount: false,
      },
      payload: { amount: "" },
    };
  },

  computed: {
    maxAmount() {
      return this.esopToken.supply - this.esopToken.total_allocated;
    },
  },

  methods: {
    convertToLocale,

    topUp() {
      this.amountValid = true;
      setTimeout(() => {
        if (!this.validInput.amount) return;
        // console.log(this.payload);
      }, 500);
    },

    setAmount(amount) {
      this.payload.amount = amount;
    },
    shareNumberValid(valid) {
      this.validInput.amount = valid;
    },
    validate() {
      this.amountValid = false;
    },
  },
};
</script>

<style lang="scss" scoped></style>
